export default {
    nodes: [],
    inputs: {},
    lastItemId: null
}